import {Div, HTMLView, HeaderBack} from 'components';
import {Ecolors} from 'constant';
import React, {useEffect, useState} from 'react';
import {ScrollView} from 'react-native-gesture-handler';
import {useSafeAreaInsets} from 'react-native-safe-area-context';
import {apiEvent} from 'services/apis/apiEvent';

function RegulationModal() {
  const [data, setData] = useState<any>({});
  const insets = useSafeAreaInsets();
  useEffect(() => {
    getData();
    return () => {};
  }, []);

  const getData = async () => {
    try {
      const r = await apiEvent.getRegulationEvent();
      if (r.status == 200) {
        setData(r.data);
      }
    } catch (error) {}
  };

  return (
    <Div flex={1} backgroundColor={Ecolors.whiteColor}>
      <HeaderBack type={2} title={`eventreward.quydinhchuongtrinh`} />
      <ScrollView showsVerticalScrollIndicator={false}>
        <Div paddingHorizontal={8}>
          <HTMLView
            source={{
              html: data?.content || '',
            }}
          />
          <Div height={insets.bottom + 20} />
        </Div>
      </ScrollView>
    </Div>
  );
}

export default React.memo(RegulationModal);
